// @flow

import React from 'react'
import { styles as s } from './style'

export default class OrderTestsLayout extends React.Component {
  props: {
    header: React.Element<any>,
    table: React.Element<any>,
    footer: React.Element<any>,
  }

  render (): React.Element<any> {
    return (
      <div style={s.orderTestsLayout}>
        <div style={s.layoutContent}>

          <div style={s.layoutHeader}>
            { this.props.header }
          </div>

          <div style={s.layoutTable}>
            { this.props.table }
          </div>

          <div style={s.layoutFooter}>
            { this.props.footer }
          </div>

        </div>
      </div>
    )
  }
}

